/** Authenticator setup: QR code to scan (drawn here, so the secret never leaves the page) plus the key to type. */
import { useMemo } from 'react';
import { qrSvg } from '@civilos/domain';

export function AuthenticatorKey({ secret, otpauthUri }: { secret: string; otpauthUri: string }) {
  const svg = useMemo(() => qrSvg(otpauthUri, 200), [otpauthUri]);
  return (
    <div className="authkey">
      <ol className="small authkey-steps">
        <li>Open Google Authenticator (or Microsoft Authenticator) on your phone.</li>
        <li>
          Tap <strong>+</strong> → <strong>Scan a QR code</strong>, and point it at this code.
        </li>
        <li>Type the 6-digit code it shows below.</li>
      </ol>
      <div className="authkey-qr" role="img" aria-label="QR code for your authenticator app" dangerouslySetInnerHTML={{ __html: svg }} />
      <details className="small">
        <summary>Can’t scan? Enter the key instead</summary>
        In the app choose <strong>Enter a setup key</strong>, type this key, and pick <strong>Time based</strong>:
        <code className="secret">{secret.match(/.{1,4}/g)?.join(' ')}</code>
        On this phone? <a href={otpauthUri}>Open in authenticator app</a>
      </details>
    </div>
  );
}
